import './TokenBase-57c65c47.css';

var classes = {"TokenBase":"prc-Token-TokenBase-PfQzJ"};

export { classes as default };
